export const apiForFormBuilder = "https://form.kapsul.org.tr/form-builder";
export const apiForAuthMS = `https://kale.kapsul.org.tr/auth`;
